
export interface IBookingInfoContent {
    storyId: number;
    instructions: string;
    token: string;
    unlockCodes: string[];
    entry: IStoryProductBooking;

    description?: string;
}

export interface IBookingInterceptorResult {
    storyId: number;
    registered: boolean;
    message: string;
    storyProductBooking: IStoryProductBooking;
    unlockCodes: string[];
}

export interface IStoryProductBooking {
    id?: number,
    storyId?: number,
    storyProductId?: number,
    customerEmail?: string,
    customerName?: string,
    customerPhone?: string,
    bookingReference?: string,
    bookingAmount?: number,
    emailSent?: number,
    timestamp?: Date,
    bookingTimestamp?: Date,
    state?: number,
    sentEmail?: number,
    sentSms?: number,
    sentReminder?: number,
    sentReviewReminder?: number,
    sentStatusReminder?: number,
    productReference?: string,
    providerId?: number,
    providerOtaId?: number,
    // other
    otherBookingReferences?: string[],

    customerPhoneValid?: boolean
}

export enum EOTA {
    manual = -1,
    viator = 1,
    getyourguide = 2,
    tripadvisor = 3,
    eventbrite = 4,
    tripcom = 6,
    website = 10,
    shopify = 11
}

export enum EProviderPrefix {
    OTA = 100,
    integration = 200
}